import script from "./TheAdminCoredata.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAdminCoredata.vue?vue&type=script&setup=true&lang=js"

import "./TheAdminCoredata.vue?vue&type=style&index=0&id=6bbea172&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbea172"]])

export default __exports__